(function($) {
    $(document).ready(function() {
        let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
            paramObj = {
                url: myajax,
                action: 'filters_ajax',
                tag: '',
                searchKeyword: '',
                paged: 1,
                pageId: '',
                callType: 'default',
            },
            isLoaded = true;

        function filters(paramObj) {
            paramObj.searchKeyword = $('.js-search-keyword').val();
            paramObj.pageId = $('main').attr("data-id");

            $.ajax({
                url: paramObj.url,
                data: paramObj,
                type: 'post',
                beforeSend: function H() {
                    $('.js-post-list').css('opacity', '0.3');
                },
                success(result) {
                    if(paramObj.callType === 'default') {
                        $('html, body').animate({ scrollTop: $('.js-post-list').offset().top - 120 }, 300);
                        $('.js-post-list').html(result);
                    } else if(paramObj.callType === 'loadmore') {
                        $('.js-append-list').append(result);

                        if(paramObj.paged === $('.js-append-list').data('pages')) {
                            $('.js-loadmore').hide();
                        }
                    }
                },
                complete() {
                    $('.js-post-list').css('opacity', '1');
                    isLoaded = true;
                },
                error(result) {
                    dl.log(result);
                }
            });
        }

        $('.js-filter-tag button').on('click', function H(e) {
            e.preventDefault();

            paramObj.paged = 1;
            paramObj.callType = 'default';
            paramObj.tag = $(this).data('value');

            $('.js-filter-tag button').removeClass('active');
            $(this).addClass('active');

            filters(paramObj);
        });

        $(document).on('click', '.js-search-submit', function H(e) {
            e.preventDefault();

            paramObj.paged = 1;
            paramObj.callType = 'default';

            filters(paramObj);
        });

        $('.js-loadmore').on('click', function() {
            if(isLoaded === true && paramObj.paged <= $('.js-append-list').data('pages') - 1 ){
                isLoaded = false;
                paramObj.paged++;
                paramObj.callType = 'loadmore';

                filters(paramObj);
            }
        });

        $('.js-filter-open-single-tag a').on('click', function H(e) {
            const filterValue = $(this).data('filter');

            localStorage.setItem('selectedFilter', filterValue);
            localStorage.setItem('selectedFilterOpen', 'open');
        });


        if (localStorage.getItem('selectedFilterOpen') === 'open') {
            const selectedFilterValue = localStorage.getItem('selectedFilter');

            $(`.js-filter-tag button[data-value="${selectedFilterValue}"]`).click();

            setTimeout(function() {
                localStorage.setItem('selectedFilterOpen', '0');
            }, 1000);
        }
    });
})(jQuery);